import { useState } from 'react';
import axios from 'axios';
import '../admin.css';

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '' : 'https://muki684.com',
});

export default function Register() {
  const [err, setErr]         = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErr(''); setSuccess('');
    const { username, password, confirm } = Object.fromEntries(new FormData(e.target));
    if (password !== confirm) { setErr('Passwords do not match.'); return; }
    setLoading(true);
    try {
      await api.post('/api/users/register', { username, password });
      setSuccess('Account created. You can now sign in.');
      e.target.reset();
    } catch (err) {
      setErr(err.response?.data?.error || 'Registration failed.');
    }
    setLoading(false);
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-logo">Muki 684 <span>Admin</span></div>
        <p style={{ fontSize: '0.82rem', color: 'var(--a-text-dim)', marginBottom: '20px', textAlign: 'center' }}>
          Create a new admin account
        </p>

        {err     && <div className="login-error">{err}</div>}
        {success && <div className="login-success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="admin-form-group">
            <label>Username</label>
            <input name="username" required autoFocus autoComplete="username" />
          </div>
          <div className="admin-form-group">
            <label>Password</label>
            <input name="password" type="password" required autoComplete="new-password" />
          </div>
          <div className="admin-form-group">
            <label>Confirm Password</label>
            <input name="confirm" type="password" required autoComplete="new-password" />
          </div>
          <button type="submit" className="admin-btn admin-btn-primary"
            style={{ width: '100%', justifyContent: 'center', marginTop: '8px' }}
            disabled={loading}>
            {loading ? 'Creating account…' : 'Create Account'}
          </button>
        </form>

        <a href="/admin" className="login-back">← Back to sign in</a>
      </div>
    </div>
  );
}
